let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3OyXK")).then(() => parcelRequire('5Lzpa'));